// Dropdown.js
import React, { useRef, useEffect, useState } from "react";
import "./dropdown.css"; // Optional: create a CSS file for Dropdown styles
import upArrow from '../../assets/upArrow.svg'
import downArrow from '../../assets/downArrow.svg'
const Dropdown = ({ options, onSelect, label, selected }) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    onSelect(options[0]);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option, e) => {
    onSelect(option);
    handleClickOutside(e);
  };

  return (
    <div className="custom-select" ref={dropdownRef}>
      <div
        className="select-wrapper"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className="select">
          <span>{selected ? selected.label : label}</span>
           <div className="drop_icon">
            <img src={isOpen ? upArrow : downArrow} alt="arrow" width={'15px'}/>
           </div>
        </div>
        {isOpen && (
          <div className="dropdown-list">
            {options.map((option, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={(e) => handleOptionClick(option, e)} // Pass the option directly
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
